
import {
  ref, reactive, watch, defineComponent, onMounted, onUpdated,
} from 'vue';
import moment from 'moment';
import {
  Table, ConfigProvider,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { fontColorRender, factorColorRender, } from '@/utils/index';

export default defineComponent({
  components: {
    ConfigProvider,
    Table,
  },
  props: {
    timeFormat: {
      type: String,
      default: () => '',
      require: true,
    },
    paramType: {
      type: String,
      default: () => '',
      require: true,
    },
    listData: {
      type: Array,
      default: () => [],
      require: true,
    },
    tableType: {
      type: Number,
      default: () => 1,
      require: true,
    },
  },
  setup (props) {
    // 列表行配置
    const columns = reactive<any>({
      tableColumns: [],
    });
    // 表格数据
    const tableData = ref<any>([]);
    const paramType = ref<string>('');
    const columnsType = ref<number>(1);

    /**
     * 加载表格表头
     * @return {void}
     */
    const loadTableColumns = (): void => {
      columns.tableColumns = [];
      columns.tableColumns.push(
        {
          title: '序号',
          align: 'center',
          slots: { customRender: 'index', },
          width: 80,
          fixed: 'left',
        },
        {
          title: '站点名称',
          align: 'center',
          dataIndex: 'name',
          width: 130,
          ellipsis: true,
          fixed: 'left',
        },
        {
          title: '参数类型',
          align: 'center',
          dataIndex: paramType,
          slots: { customRender: 'type', },
          width: 130,
          ellipsis: true,
          fixed: 'left',
        }
      );
      if (tableData.value.length) {
        Object.keys(tableData.value[0]).forEach((item) => {
          if (item !== 'name' && item !== 'type' && item !== 'avg') {
            columns.tableColumns.push(
              {
                title: moment(item, props.timeFormat).format(props.timeFormat.length === 10 ?
                  `${props.timeFormat.slice(-6,-4)}-${props.timeFormat.slice(-4,-2)} ${props.timeFormat.slice(-2)}:mm` :
                  props.timeFormat.length === 8 ?
                    `${props.timeFormat.slice(-4,-2)}-${props.timeFormat.slice(-2)}` :
                    props.timeFormat),
                align: 'center',
                dataIndex: item,
                width: 120,
                ellipsis: true,
                slots: { customRender: 'data', },
              }
            );
          }
        });
      }
      columns.tableColumns.push(
        {
          title: '平均值',
          dataIndex: 'avg',
          align: 'center',
          slots: { customRender: 'avg', },
          sorter: (a: any, b: any) => a.avg - b.avg,
          sortDirections: ['descend', 'ascend',],
          width: 130,
          fixed: 'right',
        }
      );
    };
    const loadSingleStationTableColumns = (): void => {
      columns.tableColumns = [];
      columns.tableColumns.push(
        {
          title: '序号',
          align: 'center',
          slots: { customRender: 'index', },
          width: 80,
          fixed: 'left',
        },
        {
          title: '时间',
          align: 'center',
          dataIndex: 'issue',
          slots: { customRender: 'issue', },
          width: 130,
          ellipsis: true,
          fixed: 'left',
        },
        {
          title: 'AQI',
          align: 'center',
          dataIndex: 'aqi',
          width: 130,
          ellipsis: true,
          fixed: 'left',
          slots: { customRender: 'aqi', },
        },
        {
          title: 'PM2.5',
          align: 'center',
          dataIndex: 'pm25',
          width: 130,
          ellipsis: true,
          fixed: 'left',
          slots: { customRender: 'pm25', },
        },
        {
          title: 'PM10',
          align: 'center',
          dataIndex: 'pm10',
          width: 130,
          ellipsis: true,
          fixed: 'left',
          slots: { customRender: 'pm10', },
        },
        {
          title: 'SO2',
          align: 'center',
          dataIndex: 'so2',
          width: 130,
          ellipsis: true,
          fixed: 'left',
          slots: { customRender: 'so2', },
        },
        {
          title: 'NO2',
          align: 'center',
          dataIndex: 'no2',
          width: 130,
          ellipsis: true,
          fixed: 'left',
          slots: { customRender: 'no2', },
        },
        {
          title: 'O3',
          align: 'center',
          dataIndex: 'o3',
          width: 130,
          ellipsis: true,
          fixed: 'left',
          slots: { customRender: 'o3', },
        },
        {
          title: 'CO',
          align: 'center',
          dataIndex: 'co',
          width: 130,
          ellipsis: true,
          fixed: 'left',
          slots: { customRender: 'co', },
        },
        {
          title: 'TVOC',
          align: 'center',
          dataIndex: 'tvoc',
          width: 130,
          ellipsis: true,
          fixed: 'left',
          slots: { customRender: 'tvoc', },
        }
      );
    };

    const formatTime = (time:string) => moment(time, 'YYYYMMDDHHmm').format('YYYY-MM-DD HH:mm');

    watch(() => props.listData, (val) => {
      if (val.length) {
        tableData.value = [...val,];
        paramType.value = props.paramType;
      } else {
        tableData.value = [];
        columns.tableColumns = [];
        paramType.value = props.paramType;
      }

      if (props.tableType === 1) {
        loadTableColumns();
      } else {
        loadSingleStationTableColumns();
      }
    },{
      deep: true,
    });

    watch(() => props.paramType, (type) => {
      paramType.value = type;
    },{
      immediate: true,
    });

    return {
      zhCN,
      columns,
      tableData,
      fontColorRender,
      factorColorRender,
      loadTableColumns,
      columnsType,
      formatTime,
    };
  },
});
